
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { CheckCircle, Home, Package } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const CheckoutSuccess: React.FC = () => {
  const { tl } = useLanguage();
  return (
    <main className=" py-16 bg-white text-black">
      <div className="max-w-2xl mx-auto text-center bg-white">
        <div className="bg-white p-8 rounded-lg shadow-sm ">
          <div className="mb-8 flex justify-center bg-white">
            <CheckCircle size={80} className="text-foreground" />
          </div>
          
          <h1 className="text-3xl font-sans mb-4">{tl('Merci pour votre estimation', 'Thank you for your estimation', 'Grazie per la vostra richiesta di preventivo')}</h1>
          
          <p className="text-muted-foreground mb-6">{tl("Votre estimation a été enregistrée avec succès et est en cours de traitement. Vous recevrez un email de confirmation avec les détails de votre estimation.", "Your estimation has been successfully placed and is being processed. You will receive a confirmation email shortly with your estimation details.", "La vostra richiesta di preventivo è stata registrata con successo ed è in fase di elaborazione. Riceverete un'email di conferma con i dettagli del preventivo.")}
            
          </p>
          
          <div className="bg-muted p-6 rounded-md mb-8">
            <p className="font-medium mb-2">{tl("Informations d'estimation: ", "Estimation Information: ", "Informazioni preventivo: ")}<span className="text-furniture-taupe">MK-{Math.floor(Math.random() * 10000).toString().padStart(4, '0')}</span></p>
            <p className="text-sm text-muted-foreground">{tl('Utilisez ce numéro pour suivre votre estimation ou pour toute question.', 'Use this number to track your estimation or for any inquiries.', 'Utilizzate questo numero per seguire il vostro preventivo o per qualsiasi domanda.')}</p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild variant="luxury">
              <Link to="/">
                <Home size={18} className="mr-2" />
                {tl("Retour à la page d'accueil", "Return to Home", "Torna alla home")}
              </Link>
            </Button>
            
            <Button asChild variant="outline">
              <Link to="/estimates">
                <Package size={18} className="mr-2" />
                {tl('Voir mes estimations', 'View My Estimates', 'Vedi i miei preventivi')}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default CheckoutSuccess;
